import React from 'react';
import styled from 'styled-components';
import LandingPage from '../../components/LandingPage';
import Branding from '../../components/Branding';
import Card from '../../components/Common/Card';
import Row from '../../components/Common/Row';
import { LogInLink } from '../../components/ForgotPasswordLink/ForgotPasswordLink';
import Button from '../../kingpin/atoms/Button';
import Typography from 'kingpin/atoms/Typography';
import AccessCodeInput from 'components/AccessCodeInput';

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .iycCLd {
    background-color: var(--color-bg-primary) !important;
  }
`;

const Title = styled.h1`
  margin-bottom: 24px;
`;

const ButtonWrapper = styled.div`
  margin-top: 24px;
`;

const cardStyle = (useMobileLayout: boolean) => {
  if (useMobileLayout) {
    return {
      width: '100%',
    };
  }
  return {
    width: 466,
    padding: '24px 40px',
  };
};

const WallBoardSetUp = ({
  accessCode,
  onAccessCodeChange,
  onCodeComplete,
  onLogInClicked,
  isComplete,
  isLoading,
}: {
  accessCode: string;
  onAccessCodeChange: (code: string) => void;
  onCodeComplete: (code: string) => void;
  onLogInClicked: () => void;
  isComplete: boolean;
  isLoading: boolean;
}) => (
  <LandingPage>
    <React.Fragment>
      <Branding />
      <Card style={cardStyle(false)}>
        <Layout>
          <Title>
            <Typography.Header type="H1">Access Wall Board</Typography.Header>
          </Title>
        </Layout>
        <div style={{ width: '100%', marginBottom: 32 }}>
          <div style={{ marginBottom: 4 }}>
            <Typography.Body type="Label">Access Code</Typography.Body>
          </div>
          <AccessCodeInput
            value={accessCode}
            onChange={onAccessCodeChange}
            onComplete={onCodeComplete}
            testId="wallboard-access-code"
          />
        </div>
        <ButtonWrapper style={{ width: '100%' }}>
          <Button
            onClick={onLogInClicked}
            type="Secondary"
            size="Small"
            isLoading={isLoading}
            isDisabled={!isComplete}
            label="Start"
          />
        </ButtonWrapper>
        <Row spaceBetween centerAlign>
          <LogInLink />
        </Row>
      </Card>
    </React.Fragment>
  </LandingPage>
);

export default WallBoardSetUp;
